// Types
import {contractDateTime} from '@drivesally/sally-fn/lib/types';

export default ({rental: {start_date = ''} = {}} = {}) =>
  contractDateTime(start_date).format();
